export const locale = {
    lang: "zh",
    data: {
        home: {
            title: "首页",
            empty_message: "No data to display",
            new_customer: "Create New Customer",
            view_customer: "View Customers",
            new_payment_request: "Generate New Payment",
            new_booking: "Create New Booking",
        },
    },
};
